import React, { MouseEventHandler, ReactElement } from 'react';
import { Empty, Statistic } from 'antd';
import { StatisticProps } from 'antd/lib/statistic/Statistic';

import * as S from './styles';

interface StatProps {
  icon?: ReactElement;
  loading?: boolean;
  noData?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
  titleStyle?: React.CSSProperties;
}

const StatCard: React.FC<StatProps & StatisticProps> = ({
  icon,
  loading,
  noData,
  onClick,
  className,
  ...props
}) => (
  <S.CardContainer loading={loading} className={className} onClick={onClick}>
    {noData ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    ) : (
      <S.CardContent>
        {icon && <div className="stat-card-content-icon">{icon}</div>}
        <Statistic formatter={val => val} {...props} />
      </S.CardContent>
    )}
  </S.CardContainer>
);

export default StatCard;
